import { render } from "./ButtonComponent.vue?vue&type=template&id=4c351cf2&ts=true"
import script from "./ButtonComponent.vue?vue&type=script&lang=ts"
export * from "./ButtonComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__